"use client";

var __jsx = React.createElement;
import React, { createContext, useContext, useState, useRef } from "react";
const PaymentSessionContext = /*#__PURE__*/createContext(null);
export const PaymentSessionProvider = _ref => {
  let {
    children
  } = _ref;
  const {
    0: sessionData,
    1: setSessionDataState
  } = useState({});
  const sessionDataRef = useRef({});
  const getSessionData = () => {
    return sessionDataRef.current;
  };
  const setSessionData = data => {
    sessionDataRef.current = data;
    setSessionDataState(data);
  };
  const clearSessionData = () => {
    sessionDataRef.current = {};
    setSessionDataState({});
  };
  return __jsx(PaymentSessionContext.Provider, {
    value: {
      sessionData,
      setSessionData,
      clearSessionData,
      getSessionData
    }
  }, children);
};
export const usePaymentSession = () => {
  const context = useContext(PaymentSessionContext);
  if (context === null) {
    throw new Error("usePaymentSession must be used within a PaymentSessionProvider");
  }
  return context;
};